import { warn } from "@/lib/log";

/** Register the service worker for PWA offline support (production only, keeps hot-reload working in dev). */
export function registerServiceWorker() {
  if (process.env.NODE_ENV !== "production" || !("serviceWorker" in navigator)) return;
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/service-worker.js").catch((err) => warn("SW registration failed:", err));
  });
}
